import { render } from "./Servidores.vue?vue&type=template&id=32999bfc"
import script from "./Servidores.vue?vue&type=script&lang=js"
export * from "./Servidores.vue?vue&type=script&lang=js"

import "./Servidores.vue?vue&type=style&index=0&id=32999bfc&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__